import request from '@/utils/request'

export function listRechargeOrders(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/recharge.listUserRechargeOrders',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function exportRechargeOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function importRechargeOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/importRechargeOrder',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error.response.data)
    })
  })
}